jQuery(function($){

  /*
   * Load More
   */
   $('#ajax_loadmore').click(function(){
    
    $.ajax({
      url : ajax_loadmore_params.ajaxurl, // AJAX handler
      data : {
        'action': 'loadmorebutton', // the parameter for admin-ajax.php
        'query': ajax_loadmore_params.posts, // loop parameters passed by wp_localize_script()
        'page' : ajax_loadmore_params.current_page // current page
      },
      type : 'POST',
      beforeSend : function ( xhr ) {
        $('#ajax_loadmore').text('Laden...'); // some type of preloader
      },
      success : function( posts ){
        if( posts ) {
          var $grid = $('#ajax_posts_wrap');
          var $posts = $(posts);

          $('#ajax_loadmore').text( 'Toon meer' );
          // $('#ajax_posts_wrap').append( posts ); // insert new posts

          $grid.append($newElements);
          
          ajax_loadmore_params.current_page++;

          if ( ajax_loadmore_params.current_page == ajax_loadmore_params.max_page ) {
            $('#ajax_loadmore').hide(); // if last page, HIDE the button
          }
        } else {
          $('#ajax_loadmore').hide(); // if no data, HIDE the button as well
        }
      }
    });
    return false;
  });

  /*
   * Filter
   */
   //http://dev.prosper.nl/projecten/?categoryfilter=4&action=ajaxfilter&ajax_post_type=project#
   

   $('#categoryFilter').change( function() {
    ajaxFilter();
  });

   ajaxFilter = function() {
    $.ajax({
      url : ajax_loadmore_params.ajaxurl,
      data : $('#ajax_filters').serialize(), // form data
      dataType : 'json', // this data type allows us to receive objects from the server
      type : 'POST',
      beforeSend : function(xhr){
        // $('#ajax_filters').find('button').text('Filtering...');
      },
      success : function( data ){

        // when filter applied:
        // set the current page to 1
        ajax_loadmore_params.current_page = 1;

        // set the new query parameters
        ajax_loadmore_params.posts = data.posts;

        // set the new max page parameter
        ajax_loadmore_params.max_page = data.max_page;

        // change the button label back
        // $('#ajax_filters').find('button').text('Apply filter');

        // insert the posts to the container
        
        $('#ajax_posts_wrap').html(data.content);
        // $('#ajax_posts_wrap').prepend('');
        

        // hide load more button, if there are not enough posts for the second page
        if ( data.max_page < 2 ) {
          $('#ajax_loadmore').hide();
        } else {
          $('#ajax_loadmore').show();
        }
      }
    });

    // do not submit the form
    return false;

  };

  var catFilter = getUrlParameter('category');
  if( catFilter !== undefined ) {
    $("#categoryFilter").val(catFilter).change();
  }
});